export default class GridData {
	_gridIdentifier;
	_indexOfDocumentInEdition;
	_rowIndexClientSide;

	constructor(gridIdentifier, rowIndex) {
		this.gridIdentifier = gridIdentifier;
		this.rowIndex = rowIndex;
	}

	get rowIndex() {
		return this.indexOfDocumentInEdition || this.rowIndexClientSide;
	}

	set rowIndex(value) {
		if (Number.isInteger(value)) {
			this._indexOfDocumentInEdition = value;
		} else {
			this._indexOfDocumentInEdition = null;
			this.rowIndexClientSide = value;
		}
	}

	get gridIdentifier() {
		return this._gridIdentifier;
	}

	set gridIdentifier(value) {
		this._gridIdentifier = value;
	}

	get indexOfDocumentInEdition() {
		return this._indexOfDocumentInEdition;
	}

	get rowIndexClientSide() {
		return this._rowIndexClientSide;
	}

	set rowIndexClientSide(value) {
		this._rowIndexClientSide = value;
	}
}
